<script setup>
import AppLayout from '@/Layouts/AppLayout.vue';
import DashboardCard from '@/Components/DashboardCard.vue'
import {
    DocumentDuplicateIcon,
    UserGroupIcon,
    CogIcon,
    SupportIcon,
    TemplateIcon,
    UploadIcon

} from '@heroicons/vue/outline'
</script>

<template>
    <AppLayout :title="$t('Overview')">
        <template #header></template>

        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <DashboardCard
                    :icon="DocumentDuplicateIcon"
                    :href="route('containers.index')"
                    icon-foreground="text-teal-700"
                    icon-background="bg-teal-50"
                    :display-for-customer="true"
                    :display-for-consultant="true"
                    :display-for-super-user="false"
                >
                    <template #title>
                        {{ $t('Open File Storage') }}
                    </template>
                    <p class="mt-2 text-sm text-gray-500">{{ $t('In the file storage you will find a copy of your contract, your reports and invoices as well as the documents you have uploaded.') }}</p>
                    <p class="mt-2 text-sm text-gray-500">{{ $t('In the customer storage you can also upload new documents (e.g. new ID / passport, receipts etc.).') }}</p>
                </DashboardCard>

                <DashboardCard
                    :icon="UserGroupIcon"
                    :href="route('consultant-customers.index')"
                    icon-foreground="text-purple-700"
                    icon-background="bg-purple-50"
                    :display-for-customer="false"
                    :display-for-consultant="true"
                    :display-for-super-user="false"
                >
                    <template #title>
                        {{ $t('Open Customer List') }}
                    </template>
                    <p class="mt-2 text-sm text-gray-500">{{ $t('In the customer list you can view all users registered in the customer portal and assigned to you.') }}</p>
                </DashboardCard>

                <DashboardCard
                    :icon="UserGroupIcon"
                    :href="route('customers.index')"
                    icon-foreground="text-rose-700"
                    icon-background="bg-rose-50"
                    :display-for-customer="false"
                    :display-for-consultant="false"
                    :display-for-super-user="true"
                >
                    <template #title>
                        {{ $t('Open User List') }}
                    </template>
                    <p class="mt-2 text-sm text-gray-500">{{ $t('In the user overview you can view all users registered in the customer portal.') }}</p>
                </DashboardCard>

                <DashboardCard
                    :icon="TemplateIcon"
                    :href="route('container-presets.index')"
                    icon-foreground="text-indigo-700"
                    icon-background="bg-indigo-50"
                    :display-for-customer="false"
                    :display-for-consultant="false"
                    :display-for-super-user="true"
                >
                    <template #title>
                        {{ $t('Edit Storage Templates') }}
                    </template>
                    <p class="mt-2 text-sm text-gray-500">{{ $t('Please do not change anything without consulting Marcel.') }}</p>
                </DashboardCard>

                <DashboardCard
                    :icon="CogIcon"
                    :href="route('profile.show')"
                    icon-foreground="text-sky-700"
                    icon-background="bg-sky-50"
                    :display-for-customer="true"
                    :display-for-consultant="true"
                    :display-for-super-user="true"
                >
                    <template #title>
                        {{ $t('Edit User Profile') }}
                    </template>
                    <p class="mt-2 text-sm text-gray-500">{{ $t('In your user profile you can adjust your personal information, reset your password and enable / disable two-factor authentication.') }}</p>
                </DashboardCard>

                <DashboardCard
                    :icon="SupportIcon"
                    :href="route('consultants.index')"
                    icon-foreground="text-yellow-700"
                    icon-background="bg-yellow-50"
                    :display-for-customer="true"
                    :display-for-consultant="false"
                    :display-for-super-user="false"
                >
                    <template #title>
                        {{ $t('Contact Consultant') }}
                    </template>
                    <p class="mt-2 text-sm text-gray-500">{{ $t('Contact your consultant quickly and easily through our customer portal.') }}</p>
                </DashboardCard>

                <DashboardCard
                    :icon="UploadIcon"
                    :href="route('importer.index')"
                    icon-foreground="text-gray-700"
                    icon-background="bg-gray-50"
                    :display-for-customer="false"
                    :display-for-consultant="false"
                    :display-for-super-user="true"
                >
                    <template #title>
                        {{ $t('Open Import Tool') }}
                    </template>
                    <p class="mt-2 text-sm text-gray-500">{{ $t('Using the import tool you can load invoices and reports from the FTP server into the portal for customers.') }}</p>
                </DashboardCard>

            </div>
        </div>
    </AppLayout>
</template>
